angular.module('memberPortal').controller('EventsCtrl', ["$scope", "$state", "$stateParams", "$http", "$filter", "Restangular", "CwStorage", "DataService", "locations", "instructors", "styles", "eventTypes", function($scope, $state, $stateParams, $http, $filter, Restangular, CwStorage, DataService, locations, instructors, styles, eventTypes) {
  var domain, getEventsByDay, getEventsForCurrentDay, getUTCTimestamp, getValueId, parseTime, savedDate;
  $scope.locations = locations;
  $scope.instructors = instructors;
  $scope.styles = styles;
  $scope.eventTypes = eventTypes;
  $scope.data = DataService;
  $scope.isMa = DataService.martial_arts_gym;
  $scope.isShowStyleFilter = DataService.show_style_filter;
  $scope.isShowInstructorFilter = DataService.show_instructor_filter;
  $scope.isShowEventTypeFilter = DataService.show_event_type_filter;
  domain = $scope.data.domain;
  $scope.hash = $stateParams.m;
  $scope.group_events_by = DataService.group_events_by;
  $scope.fromDate = moment(new Date()).format('YYYY-MM-DD');
  $scope.currentDate = moment(new Date()).format('YYYY/MM/DD');
  savedDate = moment(CwStorage.getItem('memberPortalEventsDate'), moment.ISO_8601);
  $scope.date = $stateParams.origin !== 'sidebar' && savedDate.isValid() ? savedDate : (CwStorage.setItem('memberPortalEventsDate', void 0), moment());
  $scope.getDropdownValue = function(value, items) {
    var option;
    option = _.find(items, function(item) {
      return item.id === value;
    });
    return option != null ? option.name : void 0;
  };
  getValueId = function(key, collection) {
    var id;
    id = parseInt(CwStorage.getItem('memberPortalEventsLocation'));
    if ($scope.getDropdownValue(id, collection)) {
      return id;
    } else {
      return void 0;
    }
  };
  $scope.locationId = getValueId('memberPortalEventsLocation', locations);
  $scope.instructorId = getValueId('memberPortalEventsInstructor', instructors);
  $scope.styleId = getValueId('memberPortalEventsStyle', styles);
  $scope.eventTypeId = getValueId('memberPortalEventsEventType', eventTypes);
  $scope.eventDetails = function(event) {
    return [event.classroom_name, event.instructor_names].join(', ');
  };
  $scope.switchWeek = function(value) {
    $scope.date = $scope.date.add(value, 'weeks');
    CwStorage.setItem('memberPortalEventsDate', $scope.date.toISOString());
    return $scope.getEvents();
  };
  parseTime = function(time, event) {
    if (event.event_tz_type === 'browser') {
      return moment.utc(time, 'YYYY/MM/DD HH:mm').local();
    } else {
      return moment(time, 'YYYY/MM/DD HH:mm');
    }
  };
  $scope.startTime = function(event) {
    return parseTime(event.start_at, event).format('h:mma');
  };
  $scope.selectLocation = function(locationId) {
    $scope.locationId = locationId;
    CwStorage.setItem('memberPortalEventsLocation', locationId);
    return $scope.getEvents();
  };
  $scope.selectInstructor = function(instructorId) {
    $scope.instructorId = instructorId;
    CwStorage.setItem('memberPortalEventsInstructor', instructorId);
    return $scope.getEvents();
  };
  $scope.selectStyle = function(styleId) {
    $scope.styleId = styleId;
    CwStorage.setItem('memberPortalEventsStyle', styleId);
    return $scope.getEvents();
  };
  $scope.selectEventType = function(eventTypeId) {
    $scope.eventTypeId = eventTypeId;
    CwStorage.setItem('memberPortalEventsEventType', eventTypeId);
    return $scope.getEvents();
  };
  getEventsByDay = function(events, start, end) {
    var days, groupedEvents;
    if (start.isSame(moment(), 'week')) {
      start = moment();
    }
    days = {};
    while (start.isSameOrBefore(end, 'day')) {
      days[start.format('YYYY/MM/DD')] = [];
      start.add(1, 'days');
    }
    groupedEvents = _.groupBy(events, function(event) {
      return parseTime(event.start_at, event).format('YYYY/MM/DD');
    });
    return angular.extend(days, groupedEvents);
  };
  getEventsForCurrentDay = function(events) {
    var days, groupedEvents;
    days = {};
    groupedEvents = _.groupBy(events, function(event) {
      return parseTime(event.start_at, event).format('YYYY/MM/DD');
    });
    if (!($scope.currentDate in groupedEvents)) {
      days[$scope.currentDate] = [];
    }
    return angular.extend(days, groupedEvents);
  };
  $scope.switchDay = function(date) {
    $scope.date = moment(new Date(date));
    $scope.getEvents();
    return $scope.currentDate = moment(new Date(date)).format('YYYY/MM/DD');
  };
  $scope.showEventsDependingGroupBy = function(day) {
    return $scope.group_events_by === 'day' && day === $scope.currentDate || $scope.group_events_by === 'week';
  };
  $scope.displayStatus = function(event) {
    var order;
    switch (false) {
      case !event.member_portal_booking_status:
        return event.member_portal_booking_status;
      case !event.invite_to_waitlist:
        return 'Full (Waitlist Available)';
      case !event.on_waitlist:
        order = $filter('ordinalize')(event.waitlist_position);
        return `(${order} on waitlist)`;
    }
  };
  getUTCTimestamp = function(date) {
    var dateString;
    dateString = date.format('YYYY-MM-DDTHH:mm:ss');
    return moment.utc(dateString).format('X');
  };
  $scope.getEvents = function() {
    var end, params, start;
    $scope.isLoading = true;
    $scope.eventsByDay = {};
    start = $scope.date.clone().startOf('week');
    end = $scope.date.clone().endOf('week');
    $scope.title = start.format('YYYY') === end.format('YYYY') ? `${start.format('MMM D')} - ${end.format('MMM D, YYYY')}` : `${start.format('MMM D, YYYY')} - ${end.format('MMM D, YYYY')}`;
    params = {
      count: 500,
      location_id: $scope.locationId,
      instructor_id: $scope.instructorId,
      event_type_id: $scope.eventTypeId,
      style_id: $scope.styleId,
      start: getUTCTimestamp(start),
      end: getUTCTimestamp(end),
      browser_tz: moment().format('Z')
    };
    return Restangular.all('events').getList(params).then(function(events) {
      $scope.isLoading = false;
      return $scope.eventsByDay = (function() {
        switch ($scope.group_events_by) {
          case 'week':
            return getEventsByDay(events.plain(), start.clone(), end);
          case 'day':
            return getEventsForCurrentDay(events.plain());
        }
      })();
    });
  };
  return $scope.getEvents();
}]);
